import React from 'react';

const ChannelList = ({ channels, onSelectChannel }) => {
  return (
    <div className="container mx-auto mt-6 p-4">
      <h2 className="text-2xl font-semibold text-center mb-6">Available Channels</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
        {channels.map((channel, index) => (
          <div
            key={index}
            onClick={() => onSelectChannel(channel.url)}
            className="cursor-pointer bg-gray-900 text-white rounded-lg shadow-md hover:shadow-xl hover:bg-gray-700 transition-all p-4 flex flex-col items-center"
          >
            <img
              src={channel.logo}
              alt={channel.name}
              className="w-20 h-20 mb-3"
              style={{ width: '84px', height: '84px' }}
            />
            <p className="text-lg font-medium text-center">{channel.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChannelList;
